<template>
	<div class="login-body">
		<div class="login-wrapper">
			<div class="login-panel">
        <div>
          <div v-show="mode!=='signin'" class="logo-top-left" style="background: url('assets/irinox/logo/signup.svg') no-repeat;" />
        </div>

				<div class="login-form" v-show="mode==='signin'">
          <!-- SIGNIN -->
          <img src="assets/irinox/logo/logo-new.png" width="300" alt="Irinox FreshCloud" style="margin: 20px 0 60px 0;"/>
          <div class="title">{{$t('login.title')}}</div>
          <label for="login.email">{{$t('login.email')}}</label>
          <InputText id="login.email" :placeholder="$t('login.email_ph')" v-model="signin.email" @keyup.enter="login(!v$.signin.$invalid)" 
            :class="{'p-invalid':v$.signin.email.$invalid && signin.submitted}" />
          <label id="login.password.label" for="login.password">{{$t('login.password')}}</label>
          <Password toggleMask inputId="login.password" :placeholder="$t('login.password_ph')" v-model="signin.password" @keyup.enter="login(!v$.signin.$invalid)" :feedback="false" 
            :class="{'p-invalid':v$.signin.password.$invalid && signin.submitted}" />

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col">
                <div class="p-field-checkbox">
                  <Checkbox inputId="rememberMe" v-model="signin.rememberMe" :binary="true" />
                  <label for="rememberMe">{{$t('login.remember_me')}}</label>
                </div>
              </div>
              <div class="p-field p-col">
                  <a class="forgot-password" @click="mode='forgot'">{{$t('login.forgot_password')}}</a>
              </div>
          </div>

          <small v-if="signin.tosExpired" class="p-mt-2 p-mb-3" style="color: #f44336;">{{$t('login.tosExpired')}}</small>

          <div class="p-field-checkbox p-mb-3" v-if="signin.tosExpired">
            <Checkbox id="signin.tos" v-model="signin.tos" :binary="true" 
              :class="{'p-invalid':signin.tosExpired && !signin.tos}"/>
            <p for="signin.tos" v-html="$t('terms.tos', { url: docsMapping[$i18n.locale].tos })"></p>
          </div>
          
          <Button :label="$t('login.button')" type="button" @click="login(!v$.signin.$invalid)"></Button>
          <small v-if="signin.error" class="p-mt-4" style="color: #f44336;">{{ signin.error }}</small>
          <div class="register">{{$t('login.without_account')}} <a @click="mode='signup'">{{$t('login.register')}}</a></div>
        </div>

        <div class="login-form" v-show="mode==='signup'">
          <!-- SIGNUP -->
          <div class="title">{{$t('signup.title')}}</div>

          <Divider align="center" >
              <b>{{$t('signup.section_company')}}</b>
          </Divider>

          <label for="signup.companyName">{{$t('signup.company')}}</label>
          <InputText id="signup.companyName" type="text" v-model="signup.companyName" 
            :placeholder="$t('signup.company_ph')"
            :class="{'p-invalid':v$.signup.companyName.$invalid && signup.submitted}"/>

          <label for="signup.taxCode">{{$t('signup.taxCode')}}</label>
          <InputText id="signup.taxCode" type="text" v-model="signup.company.taxCode" 
            :placeholder="$t('signup.taxCode_ph')"
            :class="{'p-invalid':v$.signup.company.taxCode.$invalid && signup.submitted}"/>

          <label for="signup.sector">{{$t('signup.sector')}}</label>
          <Dropdown id="signup.sector" v-model="signup.company.sector" :options="sectors" optionLabel="name" optionValue="code" 
            :placeholder="$t('signup.sector_ph')"
            :class="{'p-invalid':v$.signup.company.sector.$invalid && signup.submitted}" />

          <label for="signup.countryCompany">{{$t('signup.country')}}</label>
          <Dropdown id="signup.countryCompany" v-model="signup.company.country" :options="countries" optionLabel="name" optionValue="code" :filter="true"
            :placeholder="$t('signup.country_ph')"
            :class="{'p-invalid':v$.signup.company.country.$invalid && signup.submitted}" />

          <label v-if="signup.company.country==='IT'" for="signup.district">{{$t('signup.district')}}</label>
          <InputText v-if="signup.company.country==='IT'" id="signup.district" type="text" v-model="signup.company.district" 
            :placeholder="$t('signup.district_ph')"
            :class="{'p-invalid':v$.signup.company.district.$invalid && signup.submitted}"/>
            
          <label for="signup.city">{{$t('signup.city')}}</label>
          <InputText id="signup.city" type="text" v-model="signup.company.city" 
          :placeholder="$t('signup.city_ph')"
          :class="{'p-invalid':v$.signup.company.city.$invalid && signup.submitted}"/>
            
          <label v-if="signup.company.country==='DE'" for="signup.postalCode">{{$t('signup.postalCode')}}</label>
          <InputText v-if="signup.company.country==='DE'" id="signup.district" type="text" v-model="signup.company.postalCode" 
            :placeholder="$t('signup.postalCode_ph')"
            :class="{'p-invalid':v$.signup.company.postalCode.$invalid && signup.submitted}"/>
            
          <label for="signup.phone">{{$t('signup.phone')}}</label>
          <InputText id="signup.phone" type="text" v-model="signup.company.phone" 
            :placeholder="$t('signup.phone_ph')"
            :class="{'p-invalid':v$.signup.company.phone.$invalid && signup.submitted}"/>
            
          <Divider align="center">
              <b>{{$t('signup.section_personal')}}</b>
          </Divider>

          <label for="signup.country">{{$t('signup.country')}}</label>
          <Dropdown id="signup.country" v-model="signup.country" :options="countries" optionLabel="name" optionValue="code" :filter="true"
            :placeholder="$t('signup.country_ph')"
            :class="{'p-invalid':v$.signup.country.$invalid && signup.submitted}" />

          <div class="p-grid" style="width: 92%; margin-top: 0px;">
              <div class="p-col login-form">
                  <label for="signup.firstName">{{$t('signup.firstName')}}</label>
                  <InputText id="signup.firstName" type="text" v-model="signup.firstName" 
                    :placeholder="$t('signup.firstName_ph')"
                    :class="{'p-invalid':v$.signup.firstName.$invalid && signup.submitted}"/>
              </div>
              <div class="p-col login-form">
                  <label for="signup.lastName">{{$t('signup.lastName')}}</label>
                  <InputText id="signup.lastName" type="text" v-model="signup.lastName" 
                    :placeholder="$t('signup.lastName_ph')" 
                    :class="{'p-invalid':v$.signup.lastName.$invalid && signup.submitted}"/>
              </div>
          </div>

          <Divider align="center">
              <b>{{$t('signup.section_account')}}</b>
          </Divider>

          <label for="signup.email">{{$t('signup.email')}}</label>
          <InputText id="signup.email" :placeholder="$t('signup.email_ph')" v-model="signup.email" 
            :class="{'p-invalid':v$.signup.email.$invalid && signup.submitted}"/>
          <label for="signup.password">
            {{$t('signup.password')}}
            <i class="pi pi-info-circle" v-tooltip="$t('signup.password_tooltip')"/>
          </label>
          <Password inputId="signup.password" :placeholder="$t('signup.password_ph')" v-model="signup.password" 
            :feedback="false" :class="{'p-invalid':v$.signup.password.$invalid && signup.submitted}" toggleMask />
          <div v-if="v$.signup.password.$invalid && signup.submitted" class="form-field-error">{{$t('signup.password_tooltip')}}</div>
          <label for="signup.confirmPassword">{{$t('signup.confirmPassword')}}</label>
          <Password inputId="signup.confirmPassword" :placeholder="$t('signup.confirmPassword_ph')" v-model="signup.confirmPassword" 
            :feedback="false" :class="{'p-invalid':v$.signup.confirmPassword.$invalid && signup.submitted}" toggleMask />

          <div class="terms-incipit" v-html="$t('terms.incipit', { url: docMapping.privacy })">
          </div>

          <!-- <div class="p-field-checkbox">
            <Checkbox id="signup.privacy" v-model="signup.privacy" :binary="true" 
              :class="{'p-invalid':v$.signup.privacy.$invalid && signup.submitted}"/>
            <p for="signup.privacy" v-html="$t('terms.privacy', { url: docMapping.privacy })"></p>
          </div> -->
          <div class="p-field-checkbox">
            <Checkbox v-model="signup.tos" :binary="true" 
              :class="{'p-invalid':v$.signup.tos.$invalid && signup.submitted}" :ariaLabel="$t('terms.tos', { url: docMapping.tos })"/>
            <p v-html="$t('terms.tos', { url: docMapping.tos })"></p>
          </div>
          <!-- <div class="p-field-checkbox">
            <Checkbox id="signup.mktg" v-model="signup.mktg" :binary="true" />
            <p for="signup.mktg" v-html="$t('terms.marketing', { url: docMapping.marketing })"></p>
          </div> -->
          <div class="p-field-checkbox">
            <Checkbox v-model="signup.mktg" :binary="true" :ariaLabel="$t('terms.marketing_new', { url: docMapping.privacy })"/>
            <p v-html="$t('terms.marketing_new', { url: docMapping.privacy })"></p>
          </div>

          <Button v-if="!signup.success" :label="$t('signup.button')" type="button" @click="register(!v$.signup.$invalid)" style="margin-top: 20px"></Button>
          <small v-if="!signup.success && signup.error" class="p-mt-3" style="color: #f44336;">{{$t('signup.error')}}</small>
          <div v-if="!signup.success" class="register">{{$t('signup.with_account')}} <a @click="mode='signin'">{{$t('signup.login')}}</a></div>

          <!-- <small v-if="signup.success" style="color: #068133;" class="p-mt-3" >{{$t('signup.success')}}</small>
          <Button v-if="signup.success" :label="$t('signup.loginButton')" type="button" @click="mode='signin'" style="margin-top: 20px"></Button> -->

        </div>

        <div class="login-form" v-show="mode==='confirm'">
          <!-- CONFIRM -->
          <div class="title">{{$t('confirm.title')}}</div>
          <div class="confirm-text">{{$t('confirm.text')}}</div>
          <label for="confirm.code">{{$t('confirm.code')}}</label>
          <InputText id="confirm.code" type="text" v-model="confirm.code" 
            :placeholder="$t('confirm.code_ph')"
            :class="{'p-invalid':v$.confirm.code.$invalid && confirm.submitted}"/>

          <div class="resend">{{$t('confirm.resend_text')}} <a @click="resend">{{$t('confirm.resend_button')}}</a></div>

          <Button :label="$t('confirm.confirmButton')" type="button" @click="confirmAccount(!v$.confirm.$invalid)" style="margin-top: 20px"></Button>

        </div>

        <div class="login-form" v-show="mode==='forgot'">
          <!-- FORGOT -->
          <div class="title">{{$t('forgot.title')}}</div>
          <label for="forgot.email">{{$t('forgot.email')}}</label>
          <InputText id="forgot.email" :placeholder="$t('forgot.email_ph')" v-model="forgot.email" 
            :class="{'p-invalid':v$.forgot.email.$invalid && forgot.submitted}"/>

          <Button v-if="!forgot.success" :label="$t('forgot.button')" type="button" @click="reset(!v$.forgot.$invalid)" style="margin-top: 20px"></Button>
          <small v-if="!forgot.success && forgot.error" class="p-mt-3" style="color: #f44336;">{{$t('forgot.error')}}</small>
          <div v-if="!forgot.success" class="register"><a @click="mode='signin'">{{$t('forgot.back')}}</a></div>

          <small v-if="forgot.success" style="color: #068133;" class="p-mt-3" >{{$t('forgot.success')}}</small>

        </div>

        <div v-show="mode==='signin'">
          <LocaleChanger class="p-mb-3" />
          <span class="accessibility-link" @click="() => {accessibilityDialog=true}">{{ $t('menu.accessibility') }}</span>
          <!-- <p class="accessibility-link">
            <img src="/assets/irinox/icons/accessibility_blue.svg" width="30" height="30" :alt="$t('menu.accessibility')" @click="() => {accessibilityDialog=true}"/>
          </p> -->
        </div>
        <div v-show="mode!=='signin'"></div>
			</div>
			<div class="login-image">
        <div></div>
				<div class="login-image-content">
				</div>
				<div class="image-footer"></div>
			</div>
		</div>
	</div>
  <Loader></Loader>
  <div v-show="splashscreen" class="splashscreen">
    <div class="loader-container">
        <div class="loader">
            <div class="bottom-section">
                <div class="bottom"></div>
                <div class="bottom"></div>
                <div class="bottom"></div>
                <div class="bottom"></div>
            </div>
            <div class="top-section">
                <div class="bottom"></div>
                <div class="bottom"></div>
                <div class="bottom"></div>
                <div class="bottom"></div>
            </div>
            <div class="middle"></div>
        </div>
    </div>
  </div>

<IrinoxDialogDark :visible="confirm.success" mode="success" :message="$t('confirm.confirm_success')"
    :life="3000" @update:visible="confirm.success = $event" />
<IrinoxDialogDark :visible="confirm.error" mode="error" :message="$t('confirm.confirm_error')"
    :life="3000" @update:visible="confirm.error = $event" />
<IrinoxDialogDark :visible="confirm.resendSuccess" mode="success" :message="$t('confirm.resend_success')"
    :life="3000" @update:visible="confirm.resendSuccess = $event" />
<IrinoxDialogDark :visible="confirm.resendError" mode="error" :message="$t('confirm.resend_error')"
    :life="3000" @update:visible="confirm.resendError = $event" />

<Dialog v-model:visible="accessibilityDialog" :header="$t('accessibility.title')" :modal="true" :style="{ width: '90vw', height: '90hw' }" :closeOnEscape="true" :dismissableMask="true" >
  <template #header>
    <h2>{{$t('accessibility.title')}}</h2>
  </template> 
  <AccessibilityInner />
</Dialog>

</template>

<script>
import LocaleChanger from '../components/LocaleChanger';
import Loader from '../components/Loader.vue';
import LoginService from '../service/LoginService';
import AccountService from '../service/AccountService';
import ApplianceService from '../service/ApplianceService';
import CountryService from '../service/CountryService';
import AiService from '../service/AiService';
import { required, email, sameAs, minLength, maxLength, numeric, minValue, maxValue, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../components/IrinoxDialogDark.vue';
import docsMapping from "../../public/json/docs_mapping.json"
import AccessibilityInner from '../components/misc/AccessibilityInner.vue';
export default {
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            signin: {
              email: null,
              password: null,
              rememberMe: true,
              tosExpired: false,
              tos: false,
              error: null,
              submitted: false,
            },
            signup: {
              companyName: null,
              company: {
                sector: null,
                country: null,
                city: null,
                district: null,
                postalCode: null,
                phone: null,
                taxCode: null
              },
              country: null,
              firstName: null,
              lastName: null,
              email: null,
              password: null,
              confirmPassword: null,
              // privacy: true,
              tos: false,
              mktg: false,
              error: null,
              success: false,
              submitted: false,
            },
            confirm: {
              email: null,
              password: null,
              code: null,
              error: false,
              success: false,
              resendError: false,
              resendSuccess: false,
              submitted: false,
            },
            forgot: {
              email: null,
              error: null,
              success: false,
              submitted: false,
            },
            splashscreen: false,
            mode: "signin",
            countries: [],
            docsMapping: docsMapping,
            sectors: [],
            accessibilityDialog: false,
        };
    },
    computed: {
      ...mapGetters({
          role: 'userdata/role',
          personaltoken: 'userdata/personaltoken',
        }),
      docMapping: function() {
        if(this.$i18n.locale=='en-US') {
          return this.docsMapping['us'];
        }
        return this.docsMapping[this.$i18n.locale];
      }
    },
    watch: {
      'signup.company.country': 'resetOptionalRegistrationFields',
      '$i18n.locale': 'reloadSectors'
    },
    validations() {
        return {
            signin: {
              email: {
                  required,
                  email
              },
              password: {
                  required
              },
            },
            signup: {
              companyName: {
                  required
              },
              company: {
                taxCode: {
                    required,
                    minLength: minLength(2),
                    valid: this.$functions.taxCodeCheck
                },
                sector: {
                    required
                },
                country: {
                    required
                },
                district: {
                    required: requiredIf(function() {
                      return this.signup.company.country==='IT'
                    })
                },
                city: {
                    required
                },
                postalCode: {
                  required: requiredIf(function() {
                      return this.signup.company.country==='DE'
                    })
                },
                phone: {
                    required
                }
              },
              country: {
                  required
              },
              firstName: {
                  required
              },
              lastName: {
                  required
              },
              email: {
                  required,
                  email
              },
              password: {
                  required,
                  minLength: minLength(10),
                  valid: this.$functions.passwordCheck,
              },
              confirmPassword: {
                required,
                sameAs: sameAs(this.signup.password),
              },
              // privacy: {
              //   required,
              //   sameAs: sameAs(true),
              // },
              tos:{
                required,
                sameAs: sameAs(true),
              },
            },
            forgot: {
              email: {
                  required,
                  email
              },
            },
            confirm: {
              code: {
                  required,
                  numeric,
                  minLengthValue: minLength(4),
                  maxLengthValue: maxLength(4),
                  minValueValue: minValue(0),
                  maxValueValue: maxValue(9999)
              },
            }
        }
    },
    created() {
        this.loginService = new LoginService();
        this.accountService = new AccountService();
        this.applianceService = new ApplianceService();
        this.countryService = new CountryService();
        this.aiService = new AiService();
    },
    mounted() {
        this.countryService.getCountries().then((countries) => {
            this.countries = countries;
        });
        this.reloadSectors();
        this.$store.commit('appliances/appliances', []);
        this.$store.commit('appliances/deviceTwin', null);
        this.$store.commit('appliances/labs', []);
        this.$store.commit('preferences/resetUxData');
        this.$store.commit('afterSales/reset');
        // if(this.personaltoken) {
        //   this.aiService.botDeleteChatSessionHistory(this.personaltoken);
        // }
        this.$store.commit('ai/clearChatBotMessages');
        this.$store.commit('userdata/logout');
    },
    methods: {
      reloadSectors() {
        this.sectors = [{
              name: this.$t('company.sectors.dealer'),
              code: "dealer"
            },{
              name: this.$t('company.sectors.consultant'),
              code: "consultant"
            },{
              name: this.$t('company.sectors.gastronomy'),
              code: "gastronomy"
            },{
              name: this.$t('company.sectors.bakery'),
              code: "bakery"
            },{
              name: this.$t('company.sectors.pastry'),
              code: "pastry"
            },{
              name: this.$t('company.sectors.pastry_bakery'),
              code: "pastry_bakery"
            },{
              name: this.$t('company.sectors.icecream'),
              code: "icecream"
            },{
              name: this.$t('company.sectors.foodchain'),
              code: "foodchain"
            },{
              name: this.$t('company.sectors.catering'),
              code: "catering"
            },{
              name: this.$t('company.sectors.schoolcooking'),
              code: "schoolcooking"
            },{
              name: this.$t('company.sectors.foodindustry'),
              code: "foodindustry"
            },{
              name: this.$t('company.sectors.hotel'),
              code: "hotel"
            },{
              name: this.$t('company.sectors.largedistribution'),
              code: "largedistribution"
            },{
              name: this.$t('company.sectors.nonfoodsector'),
              code: "nonfoodsector"
            },{
              name: this.$t('company.sectors.assistance'),
              code: "assistance"
            },{
              name: this.$t('company.sectors.manufacturerepresentative'),
              code: "manufacturerepresentative"
            },{
              name: this.$t('company.sectors.other'),
              code: "other"
            }];
      },
        resetOptionalRegistrationFields() {
          this.signup.company.district = null;
          this.signup.company.postalCode = null;
        },
        login: async function(isFormValid) {
            this.signin.submitted = true;

            if (!isFormValid) {
              return;
            }

            if(this.signin.tosExpired && !this.signin.tos) {
              return;
            }

            this.signin.error = null;
            this.loginService
                .personal(this.signin.email, this.signin.password)
                .then(data => {
                    this.accountService
                        .getUserinfo(data.access_token)
                        .then(async userinfo => {
                          if(userinfo.status==='ACTIVE') {
                            if(userinfo.tos || (this.signin.tosExpired && this.signin.tos)) {
                              if(this.signin.tosExpired && this.signin.tos) {
                                userinfo.tos = true;
                                await this.accountService.putUserinfo(data.access_token, userinfo);
                              }
                              let info = userinfo;
                              info.rememberMe = this.signin.rememberMe;
                              info.personal = data.access_token;
                              info.refresh = data.refresh_token;
                              this.$store.commit('userdata/personalLoginData', info);
                              this.splashscreen = true;

                              this.$i18n.locale = this.$functions.language(info.language);
                              this.$store.commit('preferences/locale', this.$i18n.locale);
                              
                              if(userinfo.role == 'USER' || userinfo.role.includes('SERVICE')) {
                                this.applianceService.getAppliances(info.personal)
                                    .then((appliances) => {
                                      this.$store.commit('appliances/appliances', appliances);
                                      this.goToHomepage();
                                    })
                                    .catch(error => {
                                      console.error("ERROR "+error);
                                      this.$store.commit('appliances/appliances', []);
                                      this.goToHomepage();
                                    });
                              } else {
                                this.goToHomepage();
                              }
                            } else {
                              this.signin.tosExpired = true;
                            }
                          } else if(userinfo.status==='INACTIVE') {
                            this.confirm.email = this.signin.email;
                            this.confirm.password = this.signin.password;
                            this.mode = "confirm";
                            this.signin.submitted = false;
                          } else {
                            this.signin.error = this.$t('login.userinfoError');
                          }
                        })
                        .catch(error => {
                            if (error.response) {
                                console.log(error.response.data); // => the response payload
                            } else {
                              console.log(JSON.stringify(error));
                            }
                            this.signin.error = this.$t('login.userinfoError');
                        });
                })
                .catch(error => {
                    if (error.response) {
                        console.log(error.response.data); // => the response payload
                        // this.signin.error = error.response.data.error_description;
                        this.signin.error = this.$t('login.loginError');
                    } else {
                        console.log(JSON.stringify(error));
                    }
                });
        },
        goToHomepage() {
          setTimeout(function() {
            this.$router.push({ name: 'dashboard' });
          }.bind(this),500);
        },
        register: async function(isFormValid) {
          this.signup.submitted = true;

          if (!isFormValid) {
            return;
          }

          this.signup.error = null;

          let newUser = {
            companyName: this.signup.companyName,
            company: this.signup.company,
            country: this.signup.country,
            firstName: this.signup.firstName,
            lastName: this.signup.lastName,
            email: this.signup.email,
            password: this.signup.password,
            tos: this.signup.tos,
            marketing: this.signup.mktg,
            brand: "IRINOX",
            language: this.$functions.locale(this.$i18n.locale),
            preferences: {
              "push_notification": true,
              "offline_mail_notification": true,
              "measurement_system": "metric",
              "hours_display_system": "24h",
              "appliance_report": true,
              "haccp_report": true,
              "alarm_mail_notification": true
            }
          };

          this.accountService.addUserWithGraph(newUser)
            .then(data => {
              console.log(JSON.stringify(data));
              if(data.code=="200") {
                this.signup.success = true;
                this.confirm.email = this.signup.email;
                this.confirm.password = this.signup.password;
                this.mode = "confirm";
              } else {
                console.error("EXCEPTION "+JSON.stringify(data));
                this.signup.error = JSON.stringify(data);
              }
            })
            .catch(error => {
              console.error(JSON.stringify(error));
              this.signup.error = JSON.stringify(error);
            });

        },
        reset: async function(isFormValid) {
          this.forgot.submitted = true;

          if (!isFormValid) {
            return;
          }

          this.forgot.error = null;

          this.accountService.resetPassword(this.forgot.email)
            .then(data => {
              console.log(JSON.stringify(data));
              if(data.code=="200") {
                this.forgot.success = true;
              } else {
                console.error("EXCEPTION "+JSON.stringify(data));
                this.forgot.error = JSON.stringify(data);
              }
            })
            .catch(error => {
              console.error(JSON.stringify(error));
              this.forgot.error = JSON.stringify(error);
            });
        },
        confirmAccount: async function(isFormValid) {
          this.confirm.submitted = true;

          if (!isFormValid) {
            return;
          }

          this.loginService
            .personal(this.confirm.email, this.confirm.password)
            .then(data => {
              this.accountService
                .checkVerificationCode(data.access_token, this.confirm.code)
                .then(data => { 
                  if(data.code=="200") {
                    this.confirm.success = true;
                    this.mode = 'signin';
                    this.signin.email = this.confirm.email;
                    this.signin.password = null;
                  } else {
                    console.error("EXCEPTION "+JSON.stringify(data));
                    this.confirm.error = true;
                  }
                })
                .catch(error => {
                  console.error(JSON.stringify(error));
                  this.confirm.error = true;
                });
            })
            .catch(error => {
              console.error(JSON.stringify(error));
              this.confirm.error = true;
            });
          
        },
        resend() {
          this.loginService
            .personal(this.confirm.email, this.confirm.password)
            .then(data => {
              this.accountService
                .resendVerificationCode(data.access_token)
                .then(data => { 
                  if(data.code=="200") {
                    this.confirm.resendSuccess = true;
                  } else {
                    console.error("EXCEPTION "+JSON.stringify(data));
                    this.confirm.resendError = true;
                  }
                })
                .catch(error => {
                  console.error(JSON.stringify(error));
                  this.confirm.resendError = true;
                });
            })
            .catch(error => {
              console.error(JSON.stringify(error));
              this.confirm.resendError = true;
            });
        }
    },
    components: {
        IrinoxDialogDark,
        LocaleChanger,
        Loader,
        AccessibilityInner,
    },
};
</script>

<style lang="scss">

.login-body .login-wrapper .login-panel .p-hidden-accessible {
  display: none;
}

.login-body .login-wrapper .login-panel .login-form .p-dropdown {
   width: 85%;
    margin-bottom: 20px;
    box-shadow: 0px 4px 10px 0px #0000001a;
    font-size: 17px;
}
.login-body .login-wrapper .login-panel .login-form .p-dropdown .p-dropdown-label {
  font-size: 17px;
  text-align: left;
}
.login-body .login-wrapper .login-panel .login-form .p-dropdown-label.p-placeholder {
  font-size: 17px;
  text-align: left;
  color: #262626;
}
.login-body .login-wrapper .login-panel .p-field-checkbox p > a {
  text-decoration: underline;
}
.pi.pi-info-circle {
  font-size: 15px;
  cursor: pointer;
}
.p-tooltip {
  font-size: 15px  !important;
}

</style>
<style lang="scss" scoped>

.login-body .login-wrapper .login-panel .login-form {
  width: 100%;
}
.login-body .login-wrapper .login-panel .login-form > input {
  max-width: none;
}
.login-body .login-wrapper .login-panel .login-form > div {
  width: 85%;
}
.login-body .login-wrapper .login-panel .login-form .p-password-input {
  width: 100% !important;
  max-width: none !important;
}

.login-body .login-wrapper .login-panel .login-form .title {
  text-align: left;
  font-size: 30px;
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 10px;
}
.login-body .login-wrapper .login-panel .login-form label {
  font-size: 17px;
  font-weight: 300;
}
.login-body .login-wrapper .login-panel .login-form label {
  width: 85%;
  font-size: 17px;
  text-align: left;
  font-weight: 600;
}
.login-body .login-wrapper .login-panel .login-form .forgot-password {
  font-size: 17px;
  font-weight: 300;
  float: right;
}
.login-body .login-wrapper .login-panel .login-form .register,
.login-body .login-wrapper .login-panel .login-form .resend {
  font-size: 17px;
  font-weight: 300;
  margin-top: 20px;
}
.login-body .login-wrapper .login-panel .login-form .p-col {
  padding: 0;
}

.login-body .logo-top-left {
  width: 42px; 
  height: 34px;
}

a {
  text-decoration: underline;
  cursor: pointer;
}

.login-body .login-wrapper .login-panel .p-field-checkbox p {
  font-size: 17px;
  font-weight: 300;
  color: #002445;
  margin-left: 10px;
  text-align: left;
}

.p-field-checkbox {
  margin-bottom: 5px;
}

.login-body .login-wrapper .login-panel .login-form .confirm-text {
  text-align: left;
  margin-bottom: 20px;
  font-size: 1rem;
  font-weight: 300;
}

.terms-incipit {
  font-size: 17px;
  text-align: left;
  width: 85%;
  margin-bottom: .6rem;
  margin-top: .6rem;
  font-weight: 300;
  color: #002445;
}
.terms-incipit :deep(a) {
  text-decoration: underline !important;
}

.accessibility-link {
  // text-align: right;
  cursor: pointer;
  color: #002445;
  font-size: 17px;
  font-weight: 300;
  text-decoration: underline;
}

.login-body .login-wrapper .login-panel .login-form .form-field-error {
  color: #A70008;
  margin-top: -15px;
  font-size: 15px;
  line-height: 17px;
  margin-bottom: 15px;
  text-align: left;
}

</style>

